module.exports = __webpack_public_path__ + "img/071.ff9947b5.png";